import { useToasts, type ToastKind } from '../stores/toasts';

const STYLE: Record<ToastKind, { cls: string; icon: string }> = {
  capture: { cls: 'border-volt/60 bg-ink-850', icon: '⬢' },
  lost: { cls: 'border-enemy/60 bg-ink-850', icon: '⚔️' },
  nearby: { cls: 'border-sky/60 bg-ink-850', icon: '📡' },
  level: { cls: 'border-gold/60 bg-ink-850', icon: '⭐' },
  success: { cls: 'border-volt/40 bg-ink-850', icon: '✓' },
  error: { cls: 'border-enemy/50 bg-ink-850', icon: '!' },
  info: { cls: 'border-ink-600 bg-ink-850', icon: 'i' },
};

export function Toaster() {
  const { toasts, dismiss } = useToasts();
  return (
    <div className="pointer-events-none fixed inset-x-0 top-[calc(var(--safe-top)+40px)] z-50 flex flex-col items-center gap-2 px-4" aria-live="polite">
      {toasts.map((t) => (
        <button
          key={t.id}
          onClick={() => dismiss(t.id)}
          data-testid={`toast-${t.kind}`}
          className={`animate-pop pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-2xl border px-4 py-3 text-left shadow-2xl ${STYLE[t.kind].cls}`}
        >
          <span className="mt-0.5 text-lg leading-none">{STYLE[t.kind].icon}</span>
          <span>
            <span className="block font-display text-base font-bold uppercase tracking-wide">{t.title}</span>
            {t.body ? <span className="block text-sm text-ink-300">{t.body}</span> : null}
          </span>
        </button>
      ))}
    </div>
  );
}
